<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="checkout-tabs mb-4" v-if="auth == 'success'">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
        <b-tab active>
          <template v-slot:title template>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bxl-twitter bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Twitter</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Twitter</h5>
                <div class="table-responsive">
                  <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("form.user-management.label.username") }}</b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="twitter.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Api Key</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="twitter.api_key"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td width="30%"><b>Api Secret</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="twitter.api_secret"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Access Token</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="twitter.access_token"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Token Secret</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="twitter.token_secret"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn"
                            variant="success"
                            size="sm"
                            @click="updateKeyTwitter(twitter.id_pref_twitter)"
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bxl-instagram-alt bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Instagram
              </span>
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Instagram</h5>
                <div class="table-responsive">
                  <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram1.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram1.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account1 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram1.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account1">
                                  <i
                                    @click="show.account1 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account1 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram1.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram2.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram2.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account2 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram2.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account2">
                                  <i
                                    @click="show.account2 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account2 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram2.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram3.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram3.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account3 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram3.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account3">
                                  <i
                                    @click="show.account3 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account3 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram3.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram4.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram4.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account4 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram4.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account4">
                                  <i
                                    @click="show.account4 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account4 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram4.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram5.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram5.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account5 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram5.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account5">
                                  <i
                                    @click="show.account5 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account5 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram5.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram6.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram6.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account6 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram6.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account6">
                                  <i
                                    @click="show.account6 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account6 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram6.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram7.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram7.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account7 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram7.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account7">
                                  <i
                                    @click="show.account7 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account7 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram7.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram8.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram8.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account8 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram8.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account8">
                                  <i
                                    @click="show.account8 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account8 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram8.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>

                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram9.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram9.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account9 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram9.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account9">
                                  <i
                                    @click="show.account9 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account9 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram9.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>

                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.account") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram10.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.username") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="instagram10.account"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <div class="input-group">
                            <input
                              :type="show.account10 ? 'text' : 'password'"
                              class="form-control bg-light"
                              v-model="instagram10.password"
                            />
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <div v-if="show.account10">
                                  <i
                                    @click="show.account10 = false"
                                    class="fas fa-eye-slash"
                                  ></i>
                                </div>
                                <div v-else>
                                  <i
                                    @click="show.account10 = true"
                                    class="fas fa-eye"
                                  ></i>
                                </div>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn mb-4"
                            variant="success"
                            size="sm"
                            @click="
                              updateKeyInstagram(instagram10.id_pref_insta)
                            "
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bxl-telegram bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Telegram</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Telegram</h5>
                <div class="table-responsive">
                  <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%"><b>Nomer</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="telegram.nomor"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Api Id</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="telegram.api_id"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Api Hash</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="telegram.api_hash"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Anon</b></td>
                        <td width="70%">
                          <!-- <input
                                        type="text"
                                        class="form-control bg-light"
                                        v-model="telegram.anon"
                                        /> -->
                          <textarea
                            class="form-control bg-light"
                            cols="20"
                            rows="7"
                            v-model="telegram.anon"
                          >
                          </textarea>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.description") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="telegram.keterangan"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn"
                            variant="success"
                            size="sm"
                            @click="updateKeyTelegram(telegram.id_pref_tele)"
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bxs-cloud-upload bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Elastic Search</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Elastic Search</h5>
                <div class="table-responsive">
                  <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.name") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="elastic.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.ip") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="elastic.ip_address"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.description") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="elastic.keterangan"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn"
                            variant="success"
                            size="sm"
                            @click="updateKeyElastic(elastic.id_pref_elastic)"
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                  </table>

                  <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.name") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="elastic2.name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.ip") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="elastic2.ip_address"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.description") }} </b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            v-model="elastic2.keterangan"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn"
                            variant="success"
                            size="sm"
                            @click="updateKeyElastic(elastic2.id_pref_elastic)"
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bxs-map bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Google Maps</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h5 class="card-title mb-5">Maps</h5>
                  <div class="table-responsive">
                    <table class="table bordered table text-left">
                      <thead>
                        <tr>
                          <td width="30%">
                            <b>{{ $t("preferences.name") }}</b>
                          </td>
                          <td width="70%">
                            <input
                              type="text"
                              class="form-control bg-light"
                              placeholder="name"
                              v-model="maps.name"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="30%"><b>Api Key</b></td>
                          <td width="70%">
                            <input
                              type="text"
                              class="form-control bg-light"
                              placeholder="Api Key"
                              v-model="maps.api_key"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="30%">
                            <b>{{ $t("preferences.description") }}</b>
                          </td>
                          <td width="70%">
                            <input
                              type="text"
                              class="form-control bg-light"
                              v-model="maps.keterangan"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="30%"></td>
                          <td width="70%" class="text-right">
                            <b-button
                              class="btn"
                              variant="success"
                              size="sm"
                              @click="updateKeyGoogleMaps(maps.id_pref_map)"
                              ><i class="fa fa-check"></i> Update
                            </b-button>
                          </td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bx-world bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Website</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h5 class="card-title mb-5">Website</h5>
                  <div class="table-responsive">
                    <table class="table bordered table text-left">
                      <thead v-for="(web, index) in website" :key="index">
                        <tr>
                          <td width="20%">
                            <b>{{ $t("preferences.name") }}</b>
                          </td>
                          <td width="80%">
                            <input
                              type="text"
                              class="form-control bg-light"
                              v-model="web.name"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="20%"><b>ID Key</b></td>
                          <td width="80%">
                            <input
                              type="text"
                              class="form-control bg-light"
                              v-model="web.api_id"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="20%"><b>Api Key</b></td>
                          <td width="80%">
                            <input
                              type="text"
                              class="form-control bg-light"
                              v-model="web.api_key"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="20%"><b>Api Url</b></td>
                          <td width="80%">
                            <input
                              type="text"
                              class="form-control bg-light"
                              v-model="web.api_url"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="20%"></td>
                          <td width="80%" class="text-right">
                            <b-button
                              class="btn mb-4"
                              variant="success"
                              size="sm"
                              @click="updateKeyWebsite(index, web.id_pref_web)"
                              ><i class="fa fa-check"></i> Update
                            </b-button>
                          </td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bx-text bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Stopword NLP</span
              >
            </div>
          </template>
          <div class="card">
            <div class="card-body">
              <div class="tab-pane">
                <h5 class="card-title mb-5">Stopword NLP</h5>
                <div class="row">
                  <div class="col-md-10">
                    <b-form-tags
                      input-id="tags-separators"
                      v-model="stopword"
                      placeholder="Separated word with enter"
                      remove-on-delete
                    />
                  </div>
                  <!-- <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control bg-light"
                          v-on:keyup.enter="addStopWord()"
                          v-model="stopword"
                          />
                      </div> -->
                  <div class="col-md-2">
                    <b-button
                      class="btn btn-block mb-4"
                      variant="success"
                      size="md"
                      @click="addStopWord()"
                    >
                      <span
                        v-if="loading"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <i class="bx bx-loader-alt bx-sm bx-spin"></i>
                      </span>
                      <span
                        v-if="!loading"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <i class="bx bx-check-double bx-sm"></i> Add Word
                      </span>
                    </b-button>
                  </div>
                  <div class="col-md-12">
                    <p>List unrelated word for analytic :</p>
                    <simplebar style="max-height: 70vh">
                      <div class="row">
                        <div
                          v-for="(w, index) in words"
                          :key="index"
                          class="col-md-1"
                        >
                          <b-button
                            :title="w.word"
                            variant="outline-primary btn-block d-flex align-items-center mb-2 p-1"
                          >
                            <span class="text-truncate w-100">{{
                              w.word
                            }}</span>
                            <i
                              class="bx bx-x bx-sm my-auto flex-shrink-1"
                              @click="deleteStopWord(w.id)"
                            ></i>
                          </b-button>
                        </div>
                      </div>
                    </simplebar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-center">
              <i class="bx bx-sitemap bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >Rapid API</span
              >
            </div>
          </template>
          <div class="card" v-for="(r, index) in rapid" :key="index">
            <div class="card-body">
              <div class="tab-pane">
                <h5 class="card-title mb-5">{{ r.api_name }}</h5>
                <div class="table-responsive">
                  <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.rapidapi-host") }}</b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            placeholder="api host"
                            v-model="r.api_host"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.rapidapi-header-host") }}</b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            placeholder="api header host"
                            v-model="r.api_header_host"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">
                          <b>{{ $t("preferences.rapidapi-header-key") }}</b>
                        </td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control bg-light"
                            placeholder="api header key"
                            v-model="r.api_header_key"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="70%" class="text-right">
                          <b-button
                            class="btn"
                            variant="success"
                            size="sm"
                            @click="updateRapid(index, r.id_api)"
                            ><i class="fa fa-check"></i> Update
                          </b-button>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div class="checkout-tabs mb-4 p-2" v-else>
      <div class="row">
        <div class="card p-3">
          <div class="col-12">
            <b-form-group id="input-group-3" label-for="input-2">
              <div class="row">
                <div class="col-sm-12">
                  <b-form-input
                    id="input-3"
                    v-model="pin"
                    type="text"
                    placeholder="Masukan Pin"
                    :class="{ 'is-invalid': submitted && $v.pin.$error }"
                  ></b-form-input>
                  <div
                    v-if="submitted && !$v.pin.required"
                    class="invalid-feedback"
                  >
                    Pin is required.
                  </div>
                </div>
                <span class="text-danger px-3 py-1" v-if="error_auth"
                  >*{{ error_auth }}</span
                >
              </div>
            </b-form-group>
            <div class="mt-3 my-auto">
              <b-button
                type="submit"
                variant="primary"
                class="btn-block"
                @click="cekPin"
              >
                <b-spinner
                  v-if="loading_auth"
                  label="Loading ..."
                  small
                ></b-spinner>
                <span v-if="!loading_auth"> Check </span>
                <span v-if="loading_auth"> Loading.. </span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PreferenceService from "@/helpers/preference.service.js";
import { required, email } from "vuelidate/lib/validators";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

export default {
  page: {
    title: "preferences",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: this.$t("preferences.preferences"),
      pin_access: process.env.VUE_APP_BASE_PIN,
      auth: "",
      error_auth: "",
      pin: "",
      erorr_auth: "",
      submitted: false,
      loading_auth: false,
      twitter: {},
      telegram: {},
      elastic: {},
      elastic2: {},
      maps: {},
      instagram1: "",
      instagram2: "",
      instagram3: "",
      instagram4: "",
      instagram5: "",
      instagram6: "",
      instagram7: "",
      instagram8: "",
      instagram9: "",
      instagram10: "",
      website: [],
      rapid: [],
      show: {
        account1: false,
        account2: false,
        account3: false,
        account4: false,
        account5: false,
        account6: false,
        account7: false,
        account8: false,
        account9: false,
        account10: false,
      },
      items: [
        {
          text: this.$t("menuitems.setting.text"),
          href: "#",
        },
        {
          text: this.$t("preferences.preferences"),
          active: true,
        },
      ],
      words: [],
      stopword: [],
      loading: false,
    };
  },
  validations: {
    pin: { required },
  },
  methods: {
    cekPin() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.pin) {
        this.loading_auth = true;
        if (this.pin == this.pin_access) {
          (this.auth = "success"), console.log("test");
        } else {
          this.error_auth = "Pin failed";
          this.loading_auth = false;
        }
        // this.getRandomNumber();
      }
    },
    getTwitter() {
      PreferenceService.getDetailTwitter(1)
        .then((response) => {
          this.twitter = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getInstagram() {
      PreferenceService.getAllInstagram()
        .then((response) => {
          this.instagram1 = response.data.data[0];
          this.instagram2 = response.data.data[1];
          this.instagram3 = response.data.data[2];
          this.instagram4 = response.data.data[3];
          this.instagram5 = response.data.data[4];
          this.instagram6 = response.data.data[5];
          this.instagram7 = response.data.data[6];
          this.instagram8 = response.data.data[7];
          this.instagram9 = response.data.data[8];
          this.instagram10 = response.data.data[9];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTelegram() {
      PreferenceService.getDetailTelegram(1)
        .then((response) => {
          this.telegram = response.data.data;
          console.log(response.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getElastic() {
      PreferenceService.getDetailElastic(1)
        .then((response) => {
          this.elastic = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getElasticNlp() {
      PreferenceService.getDetailElastic(2)
        .then((response) => {
          this.elastic2 = response.data.data;
          console.log("nlp", response.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMaps() {
      PreferenceService.getDetailMaps(1)
        .then((response) => {
          this.maps = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWebsite() {
      PreferenceService.getAllWebsite()
        .then((response) => {
          this.website = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRapid() {
      this.rapid = [0];
      PreferenceService.getRapidApi()
        .then((response) => {
          this.rapid = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    updateKeyTwitter(id) {
      var data = this.twitter;
      PreferenceService.updateTwitter(data, id)
        .then((response) => {
          var x = response.data.data;
          Swal.fire(response.data.message, "", "success");
          this.getTwitter();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateKeyInstagram(id) {
      if (id === 1) {
        var data = this.instagram1;
      } else if (id === 2) {
        var data = this.instagram2;
      } else if (id === 3) {
        var data = this.instagram3;
      } else if (id === 4) {
        var data = this.instagram4;
      } else if (id === 5) {
        var data = this.instagram5;
      } else if (id === 6) {
        var data = this.instagram6;
      } else if (id === 7) {
        var data = this.instagram7;
      } else if (id === 8) {
        var data = this.instagram8;
      } else if (id === 9) {
        var data = this.instagram9;
      } else if (id === 10) {
        var data = this.instagram10;
      }
      console.log(data);
      PreferenceService.updateInstagram(data, id)
        .then((response) => {
          var x = response.data.data;
          Swal.fire(response.data.message, "", "success");
          this.getInstagram();
          // console.log(x);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateKeyTelegram(id) {
      var data = this.telegram;
      PreferenceService.updateTelegram(data, id)
        .then((response) => {
          var x = response.data.data;
          Swal.fire(response.data.message, "", "success");
          this.getTelegram();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateKeyElastic(id) {
      if (id == 1) {
        var data_elastic = this.elastic;
      } else if (id == 2) {
        var data_elastic = this.elastic2;
      }
      console.log(id);
      PreferenceService.updateElastic(data_elastic, id)
        .then((response) => {
          var x = response.data.data;
          Swal.fire(response.data.message, "", "success");
          this.getElastic();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateKeyGoogleMaps(id) {
      var data = this.maps;
      PreferenceService.updateMaps(data, id)
        .then((response) => {
          var x = response.data.data;
          Swal.fire(response.data.message, "", "success");
          this.getMaps();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateKeyWebsite(index, id) {
      var data = this.website[index];
      PreferenceService.updateWebsite(data, id)
        .then((response) => {
          var x = response.data.data;
          Swal.fire(response.data.message, "", "success");
          this.getWebsite();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateRapid(index, id) {
      var data = this.rapid[index];
      PreferenceService.updateRapidApi(data, id)
        .then((response) => {
          Swal.fire(response.data.message, "", "success");
          this.getRapid();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    listStopWord() {
      PreferenceService.listWord()
        .then((response) => {
          this.words = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addStopWord() {
      if (this.stopword != 0) {
        try {
          this.loading = true;
          this.stopword.forEach((element) => {
            let data = {
              word: element,
            };
            PreferenceService.addWord(data)
              .then((response) => {})
              .catch((err) => {
                console.log(err);
              });
          });
        } catch (e) {
          console.log(e);
          this.stopword = [];
          this.listStopWord();
          this.loading = false;
        } finally {
          this.stopword = [];
          this.listStopWord();
          this.loading = false;
        }
      }
    },
    deleteStopWord(id) {
      PreferenceService.deleteWord(id)
        .then((response) => {
          this.listStopWord();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    this.getRapid();
    this.getInstagram();
    this.getWebsite();
    this.getTwitter();
    this.getTelegram();
    this.getElastic();
    this.getElasticNlp();
    this.getMaps();
    this.listStopWord();
  },
};
</script>

<style scoped>
.template {
  background-color: #fff;
}
</style>
